/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../../../../store/store';
import { observer } from 'mobx-react';
import moment from 'moment';
import Header from './Header';
import Footer from './Footer';
import List from './List';
import PageWrapper from '../../../../../modules/PageWrapper';
import { findKPILtc } from '../../../../../functions/findKPI';
import ButtonExel from '../../../../../modules/ButtonExel';
import VerifiedGuard from '../../../../../routing/VerifiedGuard';

const TOP_EXPORT_FIELDS = [
  'place',
  'id',
  'first_name',
  'last_name',
  'count_chats',
  'count_qualifications',
  'workspaces_id',
  'workspaces_name',
  'ltc',
  'role_id',
  'role_name',
  'is_ban',
  'ban_date',
  'is_verified',
  'verify_date',
  'created_at',
  'wallet_created_at',
  'wallet_currency',
  'wallet_details',
  'wallet_id',
  'wallet_type',
];

const getWorkspaceId = (item) => {
  return (
    item?.workspaces_id ||
    item?.workspace_id ||
    item?.workspace?.id ||
    item?.workspaces?.id ||
    ''
  );
};

const getWorkspaceName = (item) => {
  return (
    item?.workspaces_name ||
    item?.workspace_name ||
    item?.workspace?.name ||
    item?.workspaces?.name ||
    ''
  );
};

const getRoleName = (item) => {
  return item?.role_name || item?.role?.name || '';
};

const formatDateForExport = (date) => {
  if (!date) return '';
  const value = Number(date);
  return Number.isFinite(value) && value > 0
    ? moment.tz(value * 1000, 'Europe/Kyiv').format('DD.MM.YYYY HH:mm ')
    : date;
};

const getExportPlace = (place) => {
  return Number(place) === 99999 ? 0 : place ?? '';
};

const createExportRow = (item) => {
  return {
    place: getExportPlace(item?.place),
    id: item?.id ?? '',
    first_name: item?.first_name ?? '',
    last_name: item?.last_name ?? '',
    count_chats: item?.count_chats ?? item?.count_appeals ?? '',
    count_qualifications: item?.count_qualifications ?? item?.qualifications_count ?? '',
    workspaces_id: getWorkspaceId(item),
    workspaces_name: getWorkspaceName(item),
    ltc: item?.ltc ?? '',
    role_id: item?.role_id ?? '',
    role_name: getRoleName(item),
    is_ban: item?.is_ban ?? '',
    ban_date: item?.ban_date ?? '',
    is_verified: item?.is_verified ?? '',
    verify_date: item?.verify_date ?? '',
    created_at: formatDateForExport(item?.created_at),
    wallet_created_at: formatDateForExport(item?.wallet_created_at),
    wallet_currency: item?.wallet_currency ?? '',
    wallet_details: item?.wallet_details ?? '',
    wallet_id: item?.wallet_id ?? '',
    wallet_type: item?.wallet_type ?? '',
  };
};

const getWorkspaceOptions = (items) => {
  const options = (items || []).map((item) => {
    const workspace = item?.workspace || item?.workspaces;
    const id = getWorkspaceId(item) || workspace?.id;
    const name = getWorkspaceName(item) || workspace?.name;
    return {
      value: id,
      label: name ? `#${id} ${name}` : `#${id}`,
    };
  }).filter((item) => item.value);

  return options.filter((item, index, array) => {
    return array.findIndex((option) => option.value === item.value) === index;
  });
};

const filterBySelectedWorkspaces = (items, selectedWorkspaces) => {
  const selectedIds = selectedWorkspaces.map((item) => String(item.value));
  if (!selectedIds.length) return items;

  return items.filter((item) => selectedIds.includes(String(getWorkspaceId(item))));
};

const TOPLTCWrapper = () => {
  const [data, setData] = useState(null);
  const [roles, setRoles] = useState([]);
  const [time, setTime] = useState({});
  const [subtype, setSubtype] = useState(undefined);

  const getFileName = () => {
    if (subtype === 'facebook') {
      return 'fb_rating_lts_managers';
    }
    if (subtype === 'influence') {
      return 'inf_rating_lts_managers';
    }
    return 'rating_lts_managers';
  };

  return (
    <PageWrapper
      firstTimeConfig='week_sales_periods'
      breadcrumbs={[
        { title: 'Отдел продаж' },
        { isSeparator: true },
        { title: 'Рейтинг LTC', path: '/sales/ltc/top/managers', isActive: true },
      ]}
      buttonKPI={
        roles.includes(4) ||
          roles.includes(8) ||
          roles.includes(30) ||
          roles.includes(40) ||
          roles.includes(13) ||
          roles.includes(32) ? (
          <ButtonExel
            data={data}
            fieldsToKeep={TOP_EXPORT_FIELDS}
            fileName={getFileName()}
            time={time}
          />
        ) : (
          <></>
        )
      }
      title={'Рейтинг LTC'}
    >

      <TOPLTC
        setObjForExel={setData}
        setRoles={setRoles}
        setTimeForExel={setTime}
        subtype={subtype}
        setSubtype={setSubtype}
      />

    </PageWrapper>
  );
};

const TOPLTC = observer((props) => {
  const {
    isVerify,
    timeConfig,
    setPreloader,
    setObjForExel,
    setTimeForExel,
    setRoles,
    subtype,
    setSubtype,
  } = props;

  const store = useStore();


  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [footerData, setFooterData] = useState([]);
  const [workspaceOptions, setWorkspaceOptions] = useState([]);
  const [selectedWorkspaces, setSelectedWorkspaces] = useState([]);

  useEffect(() => {
    setObjForExel(null);
    setRoles(store.roles);

    // если не верифицирован — гасим лоадер и выходим
    if (!store.user?.is_verified) {
      setPreloader(false);
      return;
    }

    // если верифицирован — грузим данные
    if (timeConfig?.time_config) {
      getData();
    }
  }, [timeConfig, subtype, store.user]);

  useEffect(() => {
    applyWorkspaceFilter(allData);
  }, [selectedWorkspaces]);

  const getTopParams = () => {
    const baseParams =
      timeConfig.time_config === 'week_sales_periods'
        ? { time_config: '', time_start: '', time_end: '', subtype }
        : { ...timeConfig, subtype };

    return baseParams;
  };

  const applyWorkspaceFilter = (sourceList) => {
    const filteredList = filterBySelectedWorkspaces(sourceList, selectedWorkspaces);

    setObjForExel(filteredList.map(createExportRow));
    setData(filteredList);

    const newFooterData = filteredList.filter((item) => item.place !== 99999);
    setFooterData(newFooterData);
  };



  const getData = async () => {
    const [result, getTeams, LTCList] = await Promise.all([
      store.requestGet('Sales/Ltc/Managers/getTop', {
        params: getTopParams(),
        returnFullObj: true,
      }),
      store.requestGet(`Sales/getRdManagersList`, {
        params: { type: 'ltc' },
      }),
      store.requestGet(`Sales/getKpiLtcList`),
    ]);

    setWorkspaceOptions((prevOptions) => {
      const nextOptions = [...prevOptions, ...getWorkspaceOptions(result.data)];
      return nextOptions.filter((item, index, array) => {
        return array.findIndex((option) => option.value === item.value) === index;
      });
    });

    const newList = result.data
      .map((item) => {
        const findTeam = getTeams.find((el) => el.id === item.sales_team_id);

        return {
          ...item,
          team: findTeam,
          full_name: `${item.first_name} ${item.last_name}`,
          status: findKPILtc(LTCList, item?.count_appeals, item?.ltc),
          place: item?.place === 0 ? 99999 : item?.place,
        };
      })
      .sort((a, b) => a?.place - b?.place);

    setTimeForExel(result.time);
    setAllData(newList);
    applyWorkspaceFilter(newList);

    setPreloader(false);
  };

  if (Number(store.user?.is_verified) !== 1) {
    return (
      <div className="card">
        <div className="card-body text-center py-15">
          <h2>Требуется верификация</h2>
          <p>Доступ к рейтингу открывается по завершении испытательного срока.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header top_1={data[0]} top_2={data[1]} top_3={data[2]} />
      <List
        data={data}
        withoutOutsiders={footerData}
        setSubtype={setSubtype}
        subtype={subtype}
        workspaceOptions={workspaceOptions}
        selectedWorkspaces={selectedWorkspaces}
        setSelectedWorkspaces={setSelectedWorkspaces}
      />
      <Footer
        data={footerData.slice(footerData.length - 3, footerData.length)}
        length={footerData.length - 2}
      />
    </>
  );
}
);

export default TOPLTCWrapper;
